import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartMixed } from "@fortawesome/pro-solid-svg-icons";
import {
  faGrid2,
  faNoteMedical,
  faForklift,
  faScrewdriverWrench,
  faHourglass,
  faSquareExclamation,
  faChartBar,
  faTriangleExclamation,
  faArrowDownToBracket,
  faFileChartColumn,
  faFileInvoice,
  faBuilding,
  faFile,
  faListCheck,
} from "@fortawesome/pro-regular-svg-icons";
import { ROLES } from "./constant";
import { faMagnifyingGlassArrowsRotate } from "@fortawesome/pro-thin-svg-icons";

export interface itemProp {
  id: number;
  title: string;
  path: string;
  access_role: ROLES[];
  icon: any;
  child: itemProp[];
  classname: string;
  urlCommonWord?: string;
}

export const projectNavbar: itemProp[] = [
  {
    id: 1,
    title: "Inspection Statistics",
    path: "/project-inspection-statistics",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faChartBar} />,
    child: [],
    classname: "inspection-statistics",
    urlCommonWord: "inspection-statistics"
  },
  {
    id: 2,
    title: "Rack Health",
    path: "/project-rack-health",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faNoteMedical} />,
    child: [],
    classname: "rack-health",
    urlCommonWord: "rack-health"
  },
  {
    id: 3,
    title: "Reported Issue",
    path: "/project-reported-issue",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faSquareExclamation} />,
    classname: "reported-issue",
    urlCommonWord: "reported-issue",
    child: [],
  },
  {
    id: 4,
    title: "Testing Summary",
    path: "/project-testing-summary",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faMagnifyingGlassArrowsRotate} />,
    child: [],
    classname: "testing-summary",
    urlCommonWord: "testing-summary"
  },
  {
    id: 5,
    title: "Generalized Issues",
    path: "/project-generalized-issues",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faTriangleExclamation} />,
    child: [],
    classname: "generalized-issue",
    urlCommonWord: "generalized-issue"
  },
  {
    id: 6,
    title: "Download Issue Details",
    path: "/project-issue-details",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faArrowDownToBracket} />,
    child: [],
    classname: "project-issue-details",
    urlCommonWord: "project-issue-details",
  },
  {
    id: 7,
    title: "Generate Report",
    path: "/view-project-report",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faFileChartColumn} />,
    child: [],
    classname: "view-project",
    urlCommonWord: "view-project",
  },
  {
    id: 8,
    title: "Inspection BOQ Report",
    path: "/project-boq-report",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faFileInvoice} />,
    child: [],
    classname: "boq-report",
    urlCommonWord: "boq-report",
  },
  {
    id: 9,
    title: "Warehouse Details",
    path: "/project-details",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faBuilding} />,
    child: [],
    classname: "project-details",
    urlCommonWord: "project-details"
  },
  {
    id: 10,
    title: "File Manager",
    path: "/file-manager",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faFile} />,
    child: [],
    classname: "file-manager",
    urlCommonWord: "file-manager",
  },
  {
    id: 11,
    title: "Task Overview",
    path: "/task-overview",
    access_role: [ROLES.TPIOWNER, ROLES.TPIMANAGER],
    icon: <FontAwesomeIcon icon={faListCheck} />,
    child: [],
    classname: "task-overview",
    urlCommonWord: "task-overview"
  },
];
